// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

// Shared MUI Grid column widths (units sum to 12) so the bulk-apply consent and
// variable rows line up column-for-column. The action column is a fixed fraction
// (not auto) so it doesn't reflow when the confirm button swaps to the ✕/✓ pair,
// and is wide enough that the button never shrinks or wraps.
export const BULK_APPLY_COLUMNS = {
  primary: 3, // consent mode / variable name
  secondary: 4, // consent category / value
  scope: 3,
  action: 2,
};
